import RestApiModel from "@/api/Model/RestApiModel";

class Territory extends RestApiModel {
  static getResourceEndpoint() {
    return '/facility-territories';
  }
}

export default Territory;
